module.exports = __webpack_public_path__ + "img/logo1.ca82af14.png";